import { Control, DeepMap } from "react-hook-form";
import { humanizeString } from "../../../lib/humanize-string";
import _ from "lodash";

export interface IBaseControlProps {
  control: Control;
  name: string;
  errors: DeepMap<any, any>;
}
export const isErrorSelector = (errors: any) => (fieldName: string) => !!_.get(errors, `${fieldName}.message`);

export const errorMessageSelector = (errors: any) => (fieldName: string) =>
  isErrorSelector(fieldName)
    ? _.get(errors, `${fieldName}.message`)?.replace(fieldName, humanizeString(fieldName))
    : null;

//digs into the errors object, finds the main field, and then finds all other nested fields with errors, and returns them as concatenated strings
export const nestedErrorMessageSelector = (errors: any) => (fieldName: string) => {
  const fieldErrors = _.get(errors, fieldName);
  if (!fieldErrors) return null;
  const baseError = fieldErrors.message || null;
  if (baseError) {
    return baseError.replace(fieldName, humanizeString(fieldName));
  }

  const nestedErrors = Object.keys(fieldErrors).reduce((acc, key) => {
    const nestedField = _.get(fieldErrors, key);
    if (!nestedField) return acc;

    //check if the nested field is an object with a message
    const nestedError = fieldErrors[key]?.message;
    if (nestedError) {
      acc.push(nestedError.replace(`${fieldName}.`, "").replace(key, humanizeString(key)));
      return acc;
    }
    //if the nested field is an object, recursively check for errors
    if (typeof nestedField === "object" && !Array.isArray(nestedField) && nestedField !== null) {
      const nestedError = nestedErrorMessageSelector(fieldErrors)(`${key}`);
      if (nestedError) {
        acc.push(nestedError.replace(`${fieldName}.`, "").replace(key, humanizeString(key)));
      }
    }

    return acc;
  }, [] as string[]);
  return nestedErrors.length > 0 ? nestedErrors.join(", ") : null;
};
